import { h } from 'preact';

const SignupSubTitle = props => (
  <p class="text-center bg-info py-3">{props.children}</p>
);

export default SignupSubTitle;
